import {Public} from './Public.js';
import {ProxyServers} from './ProxyServers.js';
import {DTemplate} from './DTemplate.js';

import {ics} from './ics.js';

/**
 * Countdown is a general countdown class that counts to a particular
 * time. Then has a 'waiting' frame until a callback returns a true
 * value.
 */
export class Countdown {
	constructor(el) {
		this.el = el;
		if (!this.el) return;
		this.key = el.getAttribute(`data-key`);
		if (!this.key) {
			this.key = location.hostname.split(`.`)[0];
			console.log(`Key is set to ` + this.key);
			el.setAttribute(`data-key`, this.key);
		}
		[this.countdown, this.$] = DTemplate(`Countdown`);
		this.el.appendChild(this.countdown);
		this.$.closeButton.addEventListener(`click`, (evt)=>{
			evt.preventDefault(); evt.stopPropagation();
			this.close();
		});

		this.startTime = new Date(this.el.getAttribute(`data-start`));

		this.$.start_date.innerText = this.startTime.toLocaleDateString(undefined, 
			{ weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
		// force to 24hr and exclude secs
		this.$.start_time.innerText = this.startTime.toLocaleTimeString([], {hour12: false, hour: "2-digit", minute: "2-digit" });
		this.startUnix = this.startTime.getTime() / 1000;
		this.$.count.innerText = `waiting...`;
		this.el.classList.add(`countdown-frame`);
		this.el.addEventListener(`transitionend`, _=>{
			this.el.remove();
		});
		this.proxies = new ProxyServers();

		const queryParams = new URLSearchParams(window.location.search);
		if (queryParams.has(`start`) && queryParams.get(`start`)==`now`) {
			this.startWaiting();
		} else {
			this.tick();
		}

		this.$.calendar.addEventListener(`click`, _=>{
			const cal = ics();
			cal.addEvent(
				this.el.getAttribute(`data-title`),
				`#datafree webinar`, `${document.location}`, this.el.getAttribute(`data-start`),
					this.el.getAttribute(`data-end`));
			cal.download(this.el.getAttribute(`data-title`) + `.ics`);
		});
	}
	close() {
		this.el.classList.add('hide');
	}
	plural(n, word) {
		if (1==n) {
			return `1 ${word}`;
		}
		return `${n} ${word}s`;
	}
	hms(hOnly, mOnly, sOnly) {
		const hs = this.plural(hOnly, `hour`);
		const ms = this.plural(mOnly, `minute`);
		const ss = this.plural(sOnly, `second`);
		if (0==hOnly) {
			if (0 == mOnly) {
				return ss;
			}
			return `${ms}, ${ss}`
		}
		return `${hs}, ${ms}, ${ss}`;
	}
	dhms(dOnly, hOnly, mOnly, sOnly) {
		const ds = this.plural(dOnly, `day`);
		const hs = this.plural(hOnly, `hour`);
		const ms = this.plural(mOnly, `minute`);
		const ss = this.plural(sOnly, `second`);
		if (0==dOnly) {
			if (0==hOnly) {
				if (0 == mOnly) {
					return ss;
				}
				return `${ms}, ${ss}`
			}
			return `${hs}, ${ms}, ${ss}`;
		}
		return `${ds}, ${hs}, ${ms}, ${ss}`;
	}
	tick() {
		window.requestAnimationFrame(()=>{
			const now = new Date();
			const n = now.getTime() / 1000;

			const s = Math.floor(this.startUnix-n);
			if (s>0) {
				// get total seconds between the times
				let delta = s;

				// calculate (and subtract) whole days
				const dOnly = Math.floor(delta / 86400);
				delta -= dOnly * 86400;

				// calculate (and subtract) whole hours
				const hOnly = Math.floor(delta / 3600) % 24;
				delta -= hOnly * 3600;

				// calculate (and subtract) whole minutes
				const mOnly = Math.floor(delta / 60) % 60;
				delta -= mOnly * 60;

				// what's left is seconds
				const sOnly = Math.floor(delta % 60); 

				const txt = `${this.dhms(dOnly, hOnly, mOnly, sOnly)}...`;
				if (txt!=this.$.count.innerText) {
					this.$.count.innerText = txt;
				}
				setTimeout(_=>this.tick(), 1000-now.getMilliseconds());
			} else {
				this.startWaiting();
			}
		});
	}
	getForwardCheckTick() {
		return 5000;
	}
	// startWaiting is called when the countdown is complete, and the user is starting
	// to wait for the stream to start
	startWaiting() {
		document.dispatchEvent(new CustomEvent(`veedo-countdown-complete`));
		this.countdown.innerHTML = `Waiting to enter the #datafree live stream...`;		
	//	const now = new Date();
	// 
	// 	if (`function`==typeof window.veedoCountdownComplete) {
	// 		console.log(`FOUND window.veedoCountdownComplete function`);
	// 		window.veedoCountdownComplete(this);
	// 	} else {
	// 		setTimeout(evt=>this.waiting(), this.getForwardCheckTick()-now.getMilliseconds());
	// 	}
	// }
	// waiting() {
	// 	console.log(`Countdown.js: checking for stream ${this.key}`);
	// 	this.proxies.chooseServer()
	// 	.then( proxy => {
	// 		console.log(`Destination when ready will be: `, this.getViewingUrl(proxy));
	// 		console.log(`proxy = ${proxy} and Public.Prefix = ${Public.Prefix}`);
	// 		fetch(`//${proxy}${Public.Prefix}rest/ready/${this.key}`).then(res=>res.json())
	// 		.then(js=>{
	// 			if (!js.exists) {
	// 				// console.log(js);
	// 				let next = new Date();
	// 				setTimeout(evt=>this.waiting(), this.getForwardCheckTick()-next.getMilliseconds());
	// 			} else {
	// 				// console.log(`We're going to our ${proxy}`);
	// 				// use /route/ for more advanced routing
	// 				location = this.getViewingUrl(proxy);
	// 			}
	// 		}).catch( err=>{
	// 			console.log(`error in waiting: `, err);
	// 			let next = new Date();			
	// 			setTimeout(evt=>this.waiting(), this.getForwardCheckTick()-next.getMilliseconds());
	// 		})
	// 	});
	}
	getViewingUrl(proxy) {
		let url = `https://${proxy}`;
		if (this.el.hasAttribute(`data-dest`) && 0<this.el.getAttribute(`data-dest`).length) {
			url = url + this.el.getAttribute(`data-dest`);
		} else {
			url = url + Public.Prefix + `view/${this.key}`;
		}
		if (-1==url.indexOf(`?`)) {
			url = url + "?";
		} else {
			url = url + "&";
		}
		url = url + `from=${encodeURIComponent(document.location.host)}`;
		return url;
	}
	static init() {
		for (const el of document.querySelectorAll(`[data-instance="Countdown"]`)) {
			new Countdown(el);
		}
	}
}